document.addEventListener("DOMContentLoaded", function() {
  var splide = new Splide('#splide-slider', {
    type: 'loop',
    perPage: 1,
    autoplay: false,
    pauseOnHover: false,
    arrows: true
  });
  splide.mount();

  document.querySelectorAll('.Read-more').forEach(function (button) { 
  button.addEventListener('click', function (event) {
    event.preventDefault();
    
    var parent = this.closest('.splide-content');
    var fullText = parent.querySelector('.full-text');
    var shortText = parent.querySelector('.short-text');

    if (this.getAttribute('data-expanded') === 'true') {
      fullText.classList.add('hidden');
      this.textContent = "Read More";
      this.setAttribute('data-expanded', 'false');
    } else { 
      fullText.classList.remove('hidden');
      this.textContent = "Read Less";
      this.setAttribute('data-expanded', 'true');
    }
  });
});

});